import _ from 'lodash';
import React from 'react';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import useGetAssetClasses from '../../../../services/funds/asset-classes-service';
import useFundsStateStore from '../../common/funds-state-hook';
import { urlToSearchCriteria } from '../../common/utils';
import Filters from './type-and-asset-class-filter-components/filters';

export default function TypeAndAssetClassFilter() {
  const set = useFundsStateStore(state => state.set);
  const showAssetClassFilterHint = useFundsStateStore(state => state.showAssetClassFilterHint);
  const assetClasses = useFundsStateStore(state => state.assetClasses);
  const filteredAssetClasses = useFundsStateStore(state => state.filters.assetClasses);
  const appliedFilterAssetClasses = useFundsStateStore(state => state.appliedFilters.assetClasses);
  const filteredFundTypes = useFundsStateStore(state => state.filters.fundTypes);
  const appliedFilterFundTypes = useFundsStateStore(state => state.appliedFilters.fundTypes);
  const filterName = useFundsStateStore(state => state.filters.name);
  const filterCount = filteredAssetClasses.length + filteredFundTypes.length;
  const searchCriteria = urlToSearchCriteria();
  const type = filteredFundTypes[0];
  const [, get] = useGetAssetClasses(type, searchCriteria.series, filterName);
  const [showOptions, setShowOptions] = React.useState(false);

  useChangeAwareEffect(({ did, isMount }) => {
    (isMount || did.filterName.change || did.type.change) && get().then(({ data }) => {
      set(state => {
        state.assetClasses = _.get(data, 'assetClasses', []);
      });
    });
  }, { filterName, type });

  const clearFilter = () => (
    set(state => {
      state.filters.assetClasses = [];
      state.filters.fundTypes = [];
    })
  );

  const applyFilter = e => {
    e && e.preventDefault();
    setShowOptions(false);

    if (showAssetClassFilterHint) {
      set(state => {
        state.showAssetClassFilterHint = false;
      });
    }

    if (_.xor(filteredAssetClasses, appliedFilterAssetClasses).length > 0
      || _.xor(filteredFundTypes, appliedFilterFundTypes).length > 0) {
      set(state => {
        state.filterChanged = true;
        state.appliedFilters.assetClasses = [...filteredAssetClasses];
        state.appliedFilters.fundTypes = [...filteredFundTypes];
      });
    }
    sessionStorage.setItem('userChangedFilterCondition', 'true');
  };

  const onClick = () => {
    if (showOptions) {
      applyFilter();
    } else {
      if (showAssetClassFilterHint) {
        set(state => {
          state.showAssetClassFilterHint = false;
        });
      }
      setShowOptions(true);
    }
  };

  const onClose = () => {
    setShowOptions(false);
    set(state => {
      state.filterChanged = false;
      state.filters.assetClasses = [...appliedFilterAssetClasses];
      state.filters.fundTypes = [...appliedFilterFundTypes];
    });
  };

  /* eslint-disable no-nested-ternary */
  const className = showOptions ? 'focus' : appliedFilterAssetClasses.length > 0 || appliedFilterFundTypes.length > 0 ? 'active' : '';
  /* eslint-enable no-nested-ternary */

  return (
    <Filters
      showOptions={showOptions}
      dropdownLabel="filters"
      dropdownClassName={className}
      clearFilter={clearFilter}
      applyFilter={applyFilter}
      onClick={onClick}
      assetClasses={assetClasses}
      filterCount={filterCount}
      onClose={onClose}
    />
  );
}
